"use client";
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faMoon,
    faSearch,
    faSun,
    faClose,
    faBars,
} from "@fortawesome/free-solid-svg-icons";
import { cn } from "@pulsex/utils";
import SearchDropdown from "../Dropdown/SearchDropdown";
import Link from "next/link";
import { MenuItem as MenuItemType } from "@pulsex/types";
import { usePathname } from "next/navigation";
import { useTheme } from "@/ThemeProvider";
import MenuItem from "./MenuItem";
import { useResponsive } from "@pulsex/hooks";

export default function MainMenu({
    items,
    regionsMenu,
    isMobile,
}: {
    items?: MenuItemType[];
    regionsMenu?: MenuItemType[];
    isMobile: boolean;
}) {
    const pathname = usePathname();
    const [isSearchOpen, setIsSearchOpen] = useState(
        () => !isMobile && pathname?.includes("search")
    );
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleSearch = () => {
        setIsSearchOpen(!isSearchOpen);
    };
    const { theme, toggleTheme } = useTheme();

    useEffect(() => {
        if (theme === "dark") {
            document.documentElement.classList.add("dark");
        } else {
            document.documentElement.classList.remove("dark");
        }
    }, [theme]);
    if (!items) return;

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };
    return (
        <>
            <div className="w-full shadow-[0px_3px_7px] shadow-[#5252523d] z-50 text-blue bg-white dark:bg-bgblue dark:text-white">
                <div className="container mx-auto flex justify-between items-center h-[75px]">
                    <div className="flex items-center gap-2 h-full">
                        <Link href="/" className="w-20 lg:w-14 ">
                            <img
                                src="/images/logo.webp"
                                alt="logo"
                                className="w-full"
                            />
                        </Link>
                        {/* navbar menu */}
                        <nav
                            className={cn(
                                "h-full flex items-center",
                                "lg:transition-all lg:fixed lg:top-[75px] lg:max-h-[calc(100%-75px)] lg:right-0 lg:w-[min(100%,500px)] lg:z-50 lg:translate-x-full",
                                isMobileMenuOpen && "lg:translate-x-0"
                            )}
                        >
                            <ul
                                className={cn(
                                    "flex items-center text-[17px] gap-6 h-full",
                                    "lg:flex-col bg-white dark:bg-bgblue lg:w-full lg:items-start lg:p-6 lg:h-full lg:max-h-full lg:overflow-scroll"
                                )}
                            >
                                {/* TODO CHECK AGAIN */}
                                {isMobile && (
                                    <MenuItem
                                        key={"REGIONS_MENU_MOBILE"}
                                        item={{
                                            title: "Regions",
                                            subMenus: regionsMenu,
                                            color: "",
                                            url: "",
                                        }}
                                    />
                                )}
                                {items.map((item, index) => (
                                    <MenuItem key={index} item={item} />
                                ))}
                            </ul>
                        </nav>
                    </div>
                    <div className="flex items-center gap-1 p-0 h-8 ">
                        {isMobile || !isSearchOpen ? (
                            <div
                                className="relative z-40 p-2 bg-gray-100 rounded flex items-center justify-center font-[400] text-[15px] text-[#1c3664] hover:text-primary hover:cursor-pointer h-full w-[34px] dark:bg-ngdarkdray dark:text-white dark:hover:text-primary"
                                onClick={toggleSearch}
                            >
                                <FontAwesomeIcon icon={faSearch} className="" />
                            </div>
                        ) : (
                            !isMobile && (
                                <SearchDropdown
                                    setIsSearchOpen={setIsSearchOpen}
                                />
                            )
                        )}

                        <Link
                            href="https://almayadeen.net/"
                            target="_blank"
                            className="p-2 lg:hidden bg-gray-100 rounded flex items-center justify-center font-[400] text-[13px] text-[#1c3664] transition-all duration-500 hover:bg-blue hover:text-white hover:cursor-pointer dark:bg-ngdarkdray dark:text-white dark:hover:bg-primary h-full"
                        >
                            AR
                        </Link>

                        <Link
                            href="https://espanol.almayadeen.net/"
                            target="_blank"
                            className="p-2 lg:hidden bg-gray-100 rounded flex items-center justify-center font-[400] text-[13px] text-[#1c3664] transition-all duration-500 hover:bg-blue hover:text-white hover:cursor-pointer dark:bg-ngdarkdray dark:text-white dark:hover:bg-primary h-full"
                        >
                            ES
                        </Link>
                        {![
                            "/newsfeed",
                            "/videos",
                            "/videofeatures",
                            "/explainers",
                            "/tv",
                            "/digitalseries",
                        ].includes(pathname?.toLocaleLowerCase()) &&
                            !pathname
                                ?.toLocaleLowerCase()
                                ?.includes("videos") && (
                                <div
                                    className="p-2 mx-2  bg-gray-100 rounded flex items-center justify-center font-[400] text-[19px] text-[#1c3664] hover:cursor-pointer dark:bg-ngdarkdray dark:text-white h-full  w-[34px] lg:hidden"
                                    onClick={() => toggleTheme()}
                                >
                                    <FontAwesomeIcon
                                        icon={theme === "dark" ? faSun : faMoon}
                                        className="text-primary"
                                    />
                                </div>
                            )}

                        <Link href={"/live"} className="bg-gradient-to-r from-[#ad0000] to-[#df1717] hover:to-[#db6a0eee] inline-flex text-white transition-all duration-700 ease-in-out  items-center cursor-pointer justify-center py-[7px] px-2 rounded-[5px] text-sm h-full">
                            Live
                        </Link>
                        <div
                            className="p-2 bg-gray-100 rounded items-center justify-center font-[400] text-[19px] text-[#1c3664] hover:cursor-pointer dark:bg-ngdarkdray dark:text-white h-full w-[34px] hidden lg:flex"
                            onClick={toggleMobileMenu}
                        >
                            <FontAwesomeIcon
                                icon={isMobileMenuOpen ? faClose : faBars}
                            />
                        </div>
                    </div>
                </div>
                {isSearchOpen && isMobile && (
                    <div className="container mx-auto my-5">
                        <SearchDropdown setIsSearchOpen={setIsSearchOpen} />
                    </div>
                )}
            </div>
        </>
    );
}
